const state = () => ({
    /** Number of photo compressions currently running in parallel (0 = idle). */
    pending: 0,
});

const mutations = {
    INCREMENT(state) {
        state.pending++;
    },
    DECREMENT(state) {
        state.pending = Math.max(0, state.pending - 1);
    },
};

const actions = {
    start({ commit }) {
        commit("INCREMENT");
    },
    end({ commit }) {
        commit("DECREMENT");
    },
};

const getters = {
    isProcessing: (state) => state.pending > 0,
    pending: (state) => state.pending,
};

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
